import { useState } from 'react';
import { Form, Card, Row, Col, Button, Image } from 'react-bootstrap';
import icQ from './assets/img/ic-q.svg';
import icA from './assets/img/ic-a.svg';

const CountryVisaStay = ({ formData, handleChange, isEditPage, handleGeneralSubmit,  }) => {
    const [isEditing, setIsEditing] = useState(!isEditPage); // ✅ If adding, fields are enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // ✅ Store initial values// ✅ Enable editing mode
    
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // ✅ Store previous values
    };
    
    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleGeneralSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleGeneralSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleGeneralSubmit is not a function.');
        }
    };
    
    // ✅ Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false);
        Object.keys(tempFormData).forEach((key) => {
            handleChange({ target: { name: key, value: tempFormData[key] } });
        });
    };

    return (
        <>
            <Card className="mb-4">
                <Card.Body>
                    {/* Title and Edit Button */}
                    <Row className="align-items-center">
                        <Col>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3><span className="item-number">2. </span>Visa & Stay</h3>
                            <hr />
                        </Col>
                    </Row>
                    {isEditing ? (
                        <>
                            <Row className="mb-3">
                                <Col md={6}> 
                                    {/* Visa type */}
                                    <Form.Group controlId="visaType">
                                        <Form.Label>What types of work visas are offered to country citizens?</Form.Label>
                                        <Form.Select 
                                            name="visaType"
                                            value={formData.visaType || ''} // ✅ Ensure fallback value
                                            onChange={handleChange}
                                            disabled={!isEditing} // ✅ Disable when not editing
                                        >
                                            <option value="">Select visa requirement</option>
                                            <option value="no visa">No Visa Required</option>
                                            <option value="visa on arrival">Visa on Arrival</option>
                                            <option value="e visa">E-Visa</option>
                                            <option value="tourist visa">Tourist Visa</option>
                                            <option value="business visa">Business Visa</option>
                                            <option value="work visa">Work Visa</option>
                                            <option value="student visa">Student Visa</option>
                                            <option value="residency visa">Residency Visa</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}> 
                                    {/* Stay period without a permit */}
                                    <Form.Group controlId="noPermitPeriod">
                                        <Form.Label>How long can you stay in the country without a work permit?</Form.Label>
                                        <Form.Select 
                                            name="noPermitPeriod"
                                            value={formData.noPermitPeriod || ''} // ✅ Ensure fallback value
                                            onChange={handleChange}
                                            disabled={!isEditing} // ✅ Disable when not editing
                                        >
                                            <option value="">Select a period</option>
                                            <option value="1 month">1 month</option>
                                            <option value="3 months">3 months</option>
                                            <option value="6 months">6 months</option>
                                            <option value="1 year">1 year</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <>  
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Card>
                                        <Card.Body className="p-3">
                                            <div className="icon-text align-items-center">
                                                <span className="icon" aria-hidden="true">
                                                    <Image src={icQ} alt="What types of work visas are offered to country citizens?" />
                                                </span>
                                                <span className="text">
                                                    What types of work visas are offered to country citizens?  
                                                </span>
                                            </div>
                                        </Card.Body>
                                    </Card>

                                    <Row className="sub-card-row">
                                        <Col className="justify-content-start">
                                            <Card>
                                                <Card.Body>
                                                    <div className="icon-text align-items-center">
                                                        <span className="icon" aria-hidden="true">
                                                            <Image src={icA} alt="What types of work visas are offered to country citizens?" />
                                                        </span>
                                                        <span className="text">
                                                            <strong>{formData.visaType || "N/A"}</strong>
                                                        </span>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={6}>
                                    <Card>
                                        <Card.Body className="p-3">
                                            <div className="icon-text align-items-center">
                                                <span className="icon" aria-hidden="true">
                                                    <Image src={icQ} alt="How long can you stay in the country without a work permit?" />
                                                </span>
                                                <span className="text">
                                                    How long can you stay in the country without a work permit?  
                                                </span>
                                            </div>
                                        </Card.Body>
                                    </Card>

                                    <Row className="sub-card-row">
                                        <Col className="justify-content-start">
                                            <Card>
                                                <Card.Body>
                                                    <div className="icon-text align-items-center">
                                                        <span className="icon" aria-hidden="true">
                                                            <Image src={icA} alt="How long can you stay in the country without a work permit?" />
                                                        </span>
                                                        <span className="text">
                                                            <strong>{formData.noPermitPeriod || "N/A"}</strong>
                                                        </span>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </>
                    )}
                </Card.Body>
            </Card>
        </>
    );
};

export default CountryVisaStay;
